import React from "react";
import { Plus, FileText } from "lucide-react";

/**
 * variant="issued" — tab Chứng nhận đã cấp: cấp trực tiếp (Biểu mẫu: tab Yêu cầu + quyền template).
 * variant="requests" — một nút “Tạo yêu cầu” → modal chọn loại.
 */
const CertificateToolbar = ({
  variant = "issued",
  onTemplates = () => {},
  onOpenRequestPicker,
  onIssue,
  className = "",
  showTemplates = true,
  showCreateRequestButton = false,
  showDirectIssueButton = false,
}) => {
  const btnBase =
    "inline-flex items-center justify-center gap-2 font-bold rounded-xl transition-all active:scale-[0.98] whitespace-nowrap";
  const primary =
    "bg-red-700 text-white px-4 py-2.5 shadow-md shadow-red-100 hover:bg-red-800 text-[11px] sm:text-xs uppercase tracking-wide";
  const outline =
    "bg-white border border-gray-200 text-gray-700 px-3 py-2.5 hover:bg-gray-50 text-[11px] sm:text-xs uppercase tracking-wide";
  const outlineRed =
    "bg-white border border-red-200 text-red-800 px-3 py-2.5 hover:bg-red-50 text-[11px] sm:text-xs uppercase tracking-wide";

  return (
    <div className={`flex flex-wrap items-center justify-end gap-2 lg:flex-shrink-0 ${className}`}>
      {showTemplates ? (
        <button type="button" onClick={onTemplates} className={`${btnBase} ${outline}`} title="Quản lý biểu mẫu">
          <FileText size={18} className="shrink-0" />
          <span className="hidden min-[400px]:inline">Biểu mẫu</span>
        </button>
      ) : null}

      {variant === "requests" && showCreateRequestButton ? (
        <button
          type="button"
          onClick={onOpenRequestPicker}
          className={`${btnBase} ${primary}`}
          title="Tạo yêu cầu cấp chứng nhận"
        >
          <Plus size={18} className="shrink-0" />
          <span className="hidden sm:inline">Tạo yêu cầu</span>
          <span className="sm:hidden">Tạo</span>
        </button>
      ) : null}

      {variant === "issued" && showDirectIssueButton ? (
        <button
          type="button"
          onClick={onIssue}
          className={`${btnBase} ${outlineRed}`}
          title="Cấp nhanh không qua duyệt"
        >
          <Plus size={17} className="shrink-0" />
          <span className="hidden md:inline">Cấp trực tiếp</span>
          <span className="md:hidden">Trực tiếp</span>
        </button>
      ) : null}
    </div>
  );
};

export default CertificateToolbar;
